import { api } from '../api/client';
import { toTenDigitPhone } from '../format';
import type { SessionUser } from './session';

export interface OtpRequestResult {
  success: boolean;
  message?: string;
  /**
   * Present only when the API runs with its development OTP enabled. A production API
   * never returns it; the login form shows it as a clearly-labelled dev hint.
   */
  testOtp?: string;
}

export interface VerifyOtpResult {
  accessToken: string;
  user: SessionUser;
}

function toE164(phone: string): string {
  return `+91${toTenDigitPhone(phone)}`;
}

export function requestOtp(phone: string, signal?: AbortSignal): Promise<OtpRequestResult> {
  return api.post<OtpRequestResult>('/auth/send-otp', { phoneNumber: toE164(phone) }, { signal });
}

export function verifyOtp(phone: string, otp: string, signal?: AbortSignal): Promise<VerifyOtpResult> {
  return api.post<VerifyOtpResult>('/auth/verify-otp', { phoneNumber: toE164(phone), otp }, { signal });
}
